import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/Simranjeet.svg';

export default function Footer() {
  return (
    <>
      <footer className='relative bg-gray-50 pb-6 pt-28 md:pt-40 lg:pt-60'>
        <div className=' mx-auto px-4'>
          <div className='flex flex-wrap text-center'>
            <div className='w-full px-4'>
              <Link
                className='text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase'
                to='/'
              >
                <img alt='logo' className='mx-auto w-28' src={logo} />
              </Link>
              <h4 className='text-3xl font-semibold'>Let's keep in touch!</h4>
              <h5 className='text-lg mt-0 mb-2 text-gray-700'>
                Say 'Hi' or Lets Collaborate!
              </h5>
              <div className='mt-6 lg:mb-0 mb-6'>
                <button
                  className='bg-white text-blue-900 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2'
                  type='button'
                >
                  <a href='https://github.com/thesimranjeet'>
                    <i className='fab fa-github'></i>
                  </a>
                </button>
                <button
                  className='bg-white text-blue-900 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2'
                  type='button'
                >
                  <a href='https://twitter.com/thesimranjeet'>
                    <i className='fab fa-twitter'></i>
                  </a>
                </button>

                {/* <button
                  className="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-dribbble"></i>
                </button>
                <button
                  className="bg-white text-gray-900 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-github"></i>
                </button> */}
              </div>
            </div>
            {/* <div className='w-full lg:w-6/12 px-4'>
              <div className='flex flex-wrap items-top mb-6'>
                <div className='w-full lg:w-4/12 px-4 ml-auto'>
                  <span className='block uppercase text-gray-600 text-sm font-semibold mb-2'>
                    Useful Links
                  </span>
                  <ul className='list-unstyled'>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Link
                      </Link>
                    </li>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Link
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className='w-full lg:w-4/12 px-4'>
                  <span className='block uppercase text-gray-600 text-sm font-semibold mb-2'>
                    Other Resources
                  </span>
                  <ul className='list-unstyled'>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Link
                      </Link>
                    </li>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        className='text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm'
                        to='/'
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
          {/* <hr className='my-6 border-gray-400' /> */}
          <div className='flex flex-wrap items-center md:justify-between justify-center'>
            <div className='w-full md:w-4/12 px-4 pt-4 mx-auto text-center'>
              {/* <div className='text-sm text-gray-600 font-semibold py-1'>
                Copyright © {new Date().getFullYear()} -{' '}
                <Link Link='/' className='text-gray-600 hover:text-gray-900'>
                  Simranjeet Singh
                </Link>
                .
              </div> */}
              <div className='text-sm text-gray-600 font-semibold py-1'>
                {new Date().getFullYear()} -{' '}
                <Link Link='/' className='text-gray-600 hover:text-gray-900'>
                  Simranjeet Singh
                </Link>
                .
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
